export default function Services() {
  const services = [
    {
      title: 'Publicidad Digital',
      description:
        'Campañas estratégicas en Google Ads, Meta Ads y LinkedIn Ads enfocadas en generación de leads calificados y conversión en ventas.',
      image:
        'https://public.readdy.ai/ai/img_res/bfbe7d738c141da959d0d8d4a8ae3a05.jpg',
      icon: 'ri-megaphone-line',
    },
    {
      title: 'Creación de Contenido',
      description:
        'Contenido estratégico para Instagram, LinkedIn, TikTok y YouTube que posiciona tu marca y genera engagement con tu audiencia B2B.',
      image:
        'https://readdy.ai/api/search-image?query=creative%20content%20creation%20workspace%20with%20professional%20camera%20equipment%20laptop%20and%20social%20media%20planning%20materials%20in%20bright%20modern%20studio%20with%20clean%20white%20background%20showcasing%20strategic%20brand%20storytelling%20and%20digital%20content%20production&width=600&height=400&seq=svc2&orientation=landscape',
      icon: 'ri-article-line',
    },
    {
      title: 'Campañas Exclusivas',
      description:
        'Acciones personalizadas, lanzamientos de productos y campañas específicas diseñadas para alcanzar tus objetivos comerciales.',
      image:
        'https://readdy.ai/api/search-image?query=exclusive%20marketing%20campaign%20planning%20session%20with%20creative%20team%20brainstorming%20around%20modern%20conference%20table%20with%20presentation%20materials%20and%20strategy%20documents%20in%20professional%20bright%20office%20with%20simple%20clean%20background&width=600&height=400&seq=svc3&orientation=landscape',
      icon: 'ri-rocket-line',
    },
    {
      title: 'Capacitaciones de Venta',
      description:
        'Formación comercial y acompañamiento a equipos de venta para optimizar procesos y aumentar la efectividad en el cierre de negocios.',
      image:
        'https://readdy.ai/api/search-image?query=professional%20sales%20training%20workshop%20with%20business%20coach%20presenting%20to%20engaged%20team%20in%20modern%20corporate%20training%20room%20with%20presentation%20screen%20and%20clean%20minimalist%20design%20emphasizing%20skill%20development%20and%20team%20growth&width=600&height=400&seq=svc4&orientation=landscape',
      icon: 'ri-presentation-line',
    },
    {
      title: 'Mailing y Automatizaciones',
      description:
        'Email marketing estratégico con secuencias automatizadas que nutren leads y mantienen comunicación efectiva con tus clientes.',
      image:
        'https://readdy.ai/api/search-image?query=email%20marketing%20automation%20interface%20showing%20workflow%20diagrams%20and%20campaign%20sequences%20on%20modern%20laptop%20screen%20in%20organized%20professional%20workspace%20with%20simple%20clean%20background%20highlighting%20strategic%20communication%20and%20lead%20nurturing&width=600&height=400&seq=svc5&orientation=landscape',
      icon: 'ri-mail-send-line',
    },
  ];

  return (
    <section id="servicios" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Te mostramos nuestro rumbo
          </h2>
          <p className="text-xl text-secondary max-w-3xl mx-auto">
            Un nuevo canal de venta digital que impulsa el crecimiento de tu negocio
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all border border-gray-100 hover:border-accent"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-accent rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-primary mb-3 group-hover:text-accent transition-colors">
                  {service.title}
                </h3>
                <p className="text-secondary leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
